import React from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import styles from "./FinancialDocumentMatches.module.scss";
import { FinancialAccrualDocumentLink } from "./FinancialAccrualDocumentLink";

interface Props {
    financialDocument: FinancialDocumentExtended;
}

export const FinancialDocumentAccrualLinks: React.FC<Props> = ({
    financialDocument,
}) => {
    const { linkedInvoices, linkedBills } = financialDocument;
    const hasLinkedAccrualDocuments =
        linkedInvoices.length > 0 || linkedBills.length > 0;

    if (!hasLinkedAccrualDocuments) {
        return null;
    }

    return (
        <section
            className={styles.list}
            data-testid="financial-document-accrual-links"
        >
            {linkedInvoices.map((linkedInvoice) => (
                <FinancialAccrualDocumentLink
                    key={`invoice-${linkedInvoice.id}`}
                    linkedAccrualDocument={linkedInvoice}
                    type="invoice"
                />
            ))}
            {linkedBills.map((linkedBill) => (
                <FinancialAccrualDocumentLink
                    key={`bill-${linkedBill.id}`}
                    linkedAccrualDocument={linkedBill}
                    type="bill"
                />
            ))}
        </section>
    );
};
